<div id="container">
    <app-header></app-header>
    <div style="display: flex; flex: 1; height: calc(100% - 80px);">
        <div style="width: 225px; height: 100%">
            <app-sidebar></app-sidebar>
        </div>
        <div class="main">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
